import type { TitlesMobileProps } from './data';

import React from 'react';

import { ContactLia, TermsAndConditions, Tools } from '../TitlesDesktop';

import { Box } from '@/components';

const TitlesMobile: TitlesMobileProps = ({ plansFile }) => {
  return (
    <Box>
      <Box>
        <TermsAndConditions plansFile={plansFile} />
      </Box>
      <Box mt="66px">
        <Tools />
      </Box>
      <Box mt="66px">
        <ContactLia />
      </Box>
    </Box>
  );
};

export default TitlesMobile;
